angular.module("uib/template/tooltip/tooltip-popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/tooltip/tooltip-popup.html",
    "<div class=\"tooltip-arrow\"></div>\n" +
    "<div class=\"tooltip-inner\" ng-bind=\"content\"></div>\n" +
    "");
}]);



//////////////////
// WEBPACK FOOTER
// ../~/angular-ui-bootstrap/template/tooltip/tooltip-popup.html.js
// module id = 179
// module chunks = 0